namespace Nobox {
    export interface UploadBase64AndInsertMsgRequest {
        media?: Nobox.Web.Hubs.MessageMedia;
        msg?: ChatmessagesRow;
    }
}
